<template>
    <div class="sound_editor">
        <v-file-input v-model="soundFiles"
                      show-size
                      :accept="soundTypes"
                      :rules="soundRules"
                      label="Ajoutez d'un fichier audio..."
                      class="sound_file_upload"
                      @change="onChangeSound" />
        <v-switch v-model="newData.enableText"
                  label="Activer le mode icon" />
        <v-text-field v-if="newData.enableText"
                      v-model="newData.text"
                      filled
                      maxlength="255"
                      counter="255"
                      label="Saisie du texte..." />
    </div>
</template>

<script>
    import { fileMixinSound } from '../../../global/FileMixinSound';

    export default {
        name: 'SoundEditor',
        mixins: [fileMixinSound],
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data: () => ({
            newData: {
                soundPath: '',
                soundName: '',
                enableText: false,
                text: ''
            }
        }),
        watch: {
            newData: {
                handler (newValue) {
                    this.$emit('input', newValue);
                },
                deep: true
            },
            soundData: function (newValue) {
                if (newValue) {
                    this.$set(this.newData, 'soundPath', newValue.path);
                    this.$set(this.newData, 'soundName', newValue.name);
                }
            }
        },
        mounted () {
            this.newData = { ...this.value };
            let file = { path: this.newData.soundPath, name: this.newData.soundName };
            this.initSoundFiles(file, this.$cdnPath, true);
            this.dragAndDrop('.sound_file_upload', this.onChangeSound);
        },
        methods: {
            dragAndDrop: function (element, callback) {
                this.$el.querySelector(element).addEventListener('drop', (e) => {
                    e.preventDefault();
                    if (!this.validateSound(e.dataTransfer.files[0])) {
                        this.$toasted.error('Type of file don\'t accepted');
                    } else {
                        callback(e.dataTransfer.files[0]);
                    }
                });
                this.$el.querySelector(element).addEventListener('dragleave', (e) => {
                    e.preventDefault();
                });
                this.$el.querySelector(element).addEventListener('dragover', (e) => {
                    e.preventDefault();
                });
            }
        }
    };
</script>

<style scoped>

</style>
